import { ChangeDetectionStrategy, Component, computed, DestroyRef, inject, Injector, input, signal } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { CreateEventFormStore } from '../../new-event-form/_services/create-event-form-store.service';
import { PriceDialogComponent } from '../../_components/price-dialog/price-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EditEventFormStore } from '../../edit-event-form/_services/edit-event-form-store.service';

@Component({
  selector: 'pricing-step',
  standalone: false,
  templateUrl: './pricing-step.component.html',
  styleUrl: './pricing-step.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class PricingStepComponent {
  edit = input<boolean>(false);

  private injector = inject(Injector);

  public eventFormStore = computed(() =>
    this.edit()
      ? this.injector.get(EditEventFormStore)
      : this.injector.get(CreateEventFormStore)
  );

  public authService = inject(AuthService);

  public destroyRef = inject(DestroyRef);

  private readonly dialog = inject(MatDialog);

  public isAskingPriceEnabled = signal(false);

  public get streappEvent() {
    return this.eventFormStore().streappEvent;
  }

  openPriceSelectionWindow(selectedItem: number, currentList: string): void {
    // Check to not open multiple dialogs
    if (this.dialog.openDialogs.length == 0) {
      const isShop = currentList === 'shop';

      // Open popup to update pricing of specific media item
      let dialogRef = this.dialog.open(PriceDialogComponent, {
        data: {
          price: isShop 
            ? this.streappEvent().preUploadedShopMediaItems[selectedItem].price 
            : this.streappEvent().preUploadedMediaItems[selectedItem].price,
          priceSuggestion: isShop
            ? this.streappEvent().preUploadedShopMediaItems[selectedItem].suggestedPrice 
            : this.streappEvent().preUploadedMediaItems[selectedItem].suggestedPrice,
        },
      });

      dialogRef.afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
        // Received data from dialog-component, update price
        if (res.n) {
          this.eventFormStore().updatePriceForMediaItem(selectedItem, res.n, currentList);
        }
      });
    }
  }
}
